// Delivery staff whose *only* access is "delivery" (not an Admin/Super Admin).
// They work from the Shipments screen only. A user with "delivery" plus any
// other access (ops, finance, deliveryAdmin, ...) is NOT shipment-only and keeps
// access to the Orders module. Keep in sync with zun-api utils/shipmentAccess.js.
export const hasShipmentOnlyAccess = (user = {}) => {
  const access = Array.isArray(user?.access) ? user.access : [];
  return user?.role !== 'superAdmin'
    && user?.role !== 'admin'
    && access.includes('delivery')
    && access.every((permission) => permission === 'delivery');
};
